import React, { useEffect, useState } from "react";
import { formatDate } from "../../../functions/dateTime/formatDate";
import { Calendar } from "lucide-react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import useClickOutside from "../../../CustomHooks/useClickOutside";
import { formatDateString } from "../../../functions/dateTime/formatDateString";

const DateInput = ({ label, name, setValue, value = "", register, error }) => {
  const [date, setDate] = useState();
  const [showDatePicker, serShowDatePicker] = useState(-1);
  const { dropdownRef } = useClickOutside(() => serShowDatePicker(-1));

  const handleShowDatePicker = () => {
    serShowDatePicker((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };
  useEffect(() => {
    if (date) {
      setValue(name, formatDateString(date), { shouldValidate: true });
    } else {
      setValue(name, "");
    }
  }, [date, name, setValue]);

  useEffect(() => {
    if (value !== "") {
      setDate(value);
    }
  }, [value]);

  const today = new Date();
  const disabledDays = {
    after: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
  };

  return (
    <div>
      <label
        htmlFor="date-time-input"
        className="font-poppins text-dg2 text-xs lg:text-sm"
      >
        {label}
      </label>
      <div className="relative" ref={dropdownRef}>
        <div onClick={handleShowDatePicker} className="cursor-pointer">
          <label
            htmlFor="custom-calendar"
            className="text-xs lg:text-sm font-poppins absolute left-1 lg:left-2 pl-2 pr-3 max-lg:py-2 top-[1px] lg:top-3 bg-white"
          >
            {date ? formatDate(date) : "Select Date"}
          </label>
          <Calendar
            color="gray"
            className="absolute right-2 top-1 lg:top-2 w-4 lg:w-5"
          />
          <input
            name={name}
            type="text"
            readOnly="readonly"
            className={`text-xs w-full border-bw rounded-md cursor-pointer py-2 lg:py-[14px] px-2 lg:px-3 focus-input ${
              error ? "border-red-500" : "border-lg4"
            }`}
            {...register}
          />
        </div>
        {showDatePicker === 1 && (
          <div className="shadow-sh-1 max-w-xs absolute left-0 top-12 bg-white z-9999">
            <DayPicker
              mode="single"
              captionLayout="dropdown"
              defaultMonth={today}
              selected={date}
              onSelect={setDate}
              disableNavigation
              disabled={disabledDays}
              classNames={{
                caption_label:
                  "font-bold flex items-center mr-3 mb-2 text-xs lg:text-sm",
                head_row: "flex font-medium text-gray-900 ",
                head_cell: "w-6 lg:w-7 font-normal text-xs lg:text-sm",
                row: "flex w-full",
                cell: "text-gray-600 rounded-md h-6 lg:h-7 w-6 lg:w-7 text-center text-xs lg:text-sm p-0",
                day: "h-6 lg:h-7 w-6 lg:w-7 p-0 font-normal",
                day_range_end: "day-range-end",
                day_selected: "rounded-md focus:bg-gray-900 focus:text-white",
              }}
            />
          </div>
        )}
        <p
          className={`text-red-500 font-figtree text-xs h-4 ${
            error ? "visible" : "invisible"
          }`}
        >
          {error?.message}
        </p>
      </div>
    </div>
  );
};

export default DateInput;
